// extracted by mini-css-extract-plugin
module.exports = {"Content":"styles_Content__Yh4n7","desc":"styles_desc__QfVnV","title":"styles_title__OZut0"};